var TabServicesModule = /** @class */ (function () {
    function TabServicesModule() {
    }
    return TabServicesModule;
}());
export { TabServicesModule };
